function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M17.452,0A17.452,17.452,0,1,1,0,17.452,17.452,17.452,0,0,1,17.452,0Zm0,33.74A16.288,16.288,0,1,0,1.163,17.452,16.288,16.288,0,0,0,17.452,33.74ZM9.8,19.58l4.938-.873a.581.581,0,0,1,.617.3l1.2,2.294A9.319,9.319,0,0,0,21.3,16.554l-2.292-1.2a.581.581,0,0,1-.3-.617L19.581,9.8a.581.581,0,0,1,.247-.381,4.072,4.072,0,0,1,6.35,3.376A13.394,13.394,0,0,1,12.8,26.177a4.072,4.072,0,0,1-3.374-6.351.58.58,0,0,1,.38-.247ZM12.8,25.014A12.23,12.23,0,0,0,25.014,12.8a2.908,2.908,0,0,0-4.335-2.536l-.752,4.262,2.385,1.245a.582.582,0,0,1,.275.722,10.486,10.486,0,0,1-6.1,6.1.582.582,0,0,1-.722-.275L14.524,19.93l-4.262.752A2.908,2.908,0,0,0,12.8,25.014Zm0,0",
  transform: "translate(0.25 0.25)",
  fill: "#f6c244",
  stroke: "#f6c244",
  strokeWidth: 0.5
});

function SvgPhoneCall(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 35.403,
    height: 35.403,
    viewBox: "0 0 35.403 35.403",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhoneCall);
export default __webpack_public_path__ + "static/media/PhoneCall.956f8c55.svg";
export { ForwardRef as ReactComponent };